module.exports = __webpack_public_path__ + "img/path-5.e1bfb40d.svg";